import {Icon, view} from '@sail/ui';
import {cancel} from '@sail/icons/react/Icon';
import {defineMessages, useIntl} from 'react-intl';
import {useTheme} from '../ThemeProvider';

const messages = defineMessages({
  buttonText: {
    id: 'conversations_ui.sendUsAnEmailForm.closeButton.buttonText',
    description: 'Aria label for the button to dismiss certain forms',
    defaultMessage: 'Close',
  },
});

type Props = {
  onClick: (e: React.MouseEvent<HTMLButtonElement>) => void;
  dataTestId?: string;
};

export const SendUsAnEmailCloseButton = ({onClick, dataTestId}: Props) => {
  const intl = useIntl();
  const theme = useTheme();

  return (
    <view.button
      css={{
        display: 'flex',
        position: 'absolute',
        borderRadius: 'small',
        borderStyle: 'none',
        color: 'secondary',
        backgroundColor: 'surface',
        top: 'space.0',
        right: 'space.0',
        ':hover': {
          backgroundColor: theme.surfaceHoverColor,
        },
        ':focus': {
          focusRing: theme.focusVisibleOutline ? 'none' : undefined,
          outline: theme.focusVisibleOutline?.toString(),
        },
        padding: 'xsmall',
        bleedTop: 'xsmall',
        bleedRight: 'xsmall',
      }}
      aria-label={intl.formatMessage(messages.buttonText)}
      onClick={onClick}
      type="button"
      data-testid={dataTestId}
    >
      <Icon icon={cancel} size="small" data-testid="close-icon" />
    </view.button>
  );
};
